import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

const REPOS_URL = 'https://api.github.com/users/valaraucoo/repos?sort=created';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    repos: null
  },
  mutations: {
    SET_REPOS(state, repos) {
      state.repos = repos
    }
  },
  actions: {
    fetchRepos({ commit }) {
      axios({
        url: REPOS_URL,
        method: 'GET'
      })
        .then(response => {
          commit('SET_REPOS', response.data)
        })
        .catch(err => console.log(err));
    }
  },
  getters: {
    getRepos: state => state.repos
  },
  modules: {}
});
